/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-debugger */
/* eslint-disable use-isnan */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/*eslint-disable */
/*eslint-disable react-hooks/exhaustive-deps*/
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useContext, useEffect, useState } from 'react';
import {
    Grid,
    Typography, 
    Card,
    CardContent,
    RACButton,
    RACModalCard,
    RACTextbox,
    RACTable,
    RACTableCell,
    RACTableRow,
    RACCheckBox
} from '@rentacenter/racstrap';
import { availableCreditsStyle } from '../stylesJS/availableCreditsStyle';
import { useTranslation } from 'react-i18next';
import { agreementContext } from '../context/PaymentInformationContext';
import { barcodeStyles } from '../../stylesJS/barcodeStyles';
import CONSTANTS from '../constants/constant';
import { calculatePaymentModule } from '../../api/user';
import { ReactComponent as Alerticon } from '../../assets/images/no-records-found.svg';
import calculationModulePayloadFormation from "../../../src/refactoredComponents/microfrontends/existingFunctions/commonModulePayloadFormation";
import { ClipLoader } from "react-spinners";
import { takePaymentStyles } from '../../stylesJS/makeStyles';
import { calculateAgreementAmt } from '../../../src/utils/utils';
interface useSuspenseInterface {
    agreementNumber: string;
    useSusp: string;
    erorMsg?: string
}

export const MxSuspense = () => {
    const { agreementDetails, addSuspenseAmt, setAddSuspenseAmt, enableAddSuspense, setEnableAddSuspense, enableUseSuspense, setEnableUseSuspense
        , customerInfo, setCustomerInfo, setAgreementDetails, sameStoreAgreement, setSameStoreAgreement, featureFlags, agreementDetailsDeepClone,
        paymentWithdrawCheckbox, setPaymentWithdrawCheckbox, enableSusRadio, setEnableSusRadio, customerInfoDeepClone,
        useSusBalAmt, setUseSusBalAmt, useSusDisplayAmt, setUseSusDisplayAmt, enableAddBtn
    } = useContext(agreementContext);

    const intialSusp = customerInfo.SuspenseDetails.totalSusp;
    const [customerSusp, setCustomerSusp] = useState<string>(intialSusp);
    const [errorMessages, setErrorMessages] = useState<{ [key: string]: string }>({});
    const [errorPopup, seterrorPopup] = useState(false);
    // const [loading, setLoading] = useState(false);
    const [addBtnLoading, setAddBtnLoading] = useState(false);
    const [useBtnLoading, setUseBtnLoading] = useState(false);
    const [SecondFactorOpen, setSecondFactorOpen] = useState(false);

    useEffect(() => {
        setSameStoreAgreement(prev => {
            const prevMap = new Map(
                (prev || []).map(agr => [agr.agreementNumber, agr.useSusp])
            );
            return agreementDetails
                .filter((agr: any) => agr.storeNumber == currentStore)
                .map((agr: any) => ({
                    agreementNumber: agr?.agreementNumber,
                    useSusp: prevMap?.get(agr?.agreementNumber) ?? "0.00"
                }));
        });

        const useSuspenseAddedAgreement: string[] = [];
        sameStoreAgreement.forEach((agr) => {
            if (Number(agr.useSusp) > 0) {
                useSuspenseAddedAgreement.push(agr.agreementNumber);
            }
        });

        agreementDetails.forEach((el) => {
            if (useSuspenseAddedAgreement.includes(el.agreementNumber) && !el.selected) {
                // Reset useSusp to '0.00' only if currently different
                setSameStoreAgreement(prev => {
                    const updated = prev.map(agr =>
                        agr.agreementNumber == el.agreementNumber && agr.useSusp !== '0.00'
                            ? { ...agr, useSusp: '0.00' }
                            : agr
                    );
                    return updated;
                });

                // Restore totalAmount and totalDueAmount from deep clone, only if they differ
                const originalAgreement = agreementDetailsDeepClone.find(
                    (deep: any) => deep.agreementNumber == el.agreementNumber
                );

                setAgreementDetails(prev => {
                    let hasChanges = false;
                    const updated = prev.map(agr => {
                        if (agr.agreementNumber == el.agreementNumber) {
                            const newSuspUse = '0.00';
                            const newTotalAmount = originalAgreement?.totalAmount ?? agr.totalAmount;
                            const newTotalTax = originalAgreement?.totalTax ?? agr.totalTax;

                            if (
                                agr.mxSuspenseDetails?.suspUse !== newSuspUse ||
                                agr.totalAmount !== newTotalAmount ||
                                agr.totalDueAmount !== newTotalTax
                            ) {
                                hasChanges = true;
                                return {
                                    ...agr,
                                    mxSuspenseDetails: {
                                        ...agr.mxSuspenseDetails,
                                        suspUse: newSuspUse
                                    },
                                    totalDueAmount: (Number(newTotalAmount) + Number(newTotalTax)).toFixed(2),
                                    totalTax: newTotalTax,
                                    totalAmount: newTotalAmount,
                                };
                            }
                        }
                        return agr;
                    });
                    return hasChanges ? updated : prev;
                });

                // Restore suspense amount in customerInfo only if needed
                let usedSusp = 0;
                const totalSusp = customerInfo.SuspenseDetails.totalSusp;
                sameStoreAgreement.forEach(item => {
                    const checked = agreementDetails.some(
                        agr => item.agreementNumber == agr.agreementNumber && !agr.selected
                    );
                    if (
                        Number(item.useSusp) > 0 &&
                        useSuspenseAddedAgreement.includes(item.agreementNumber) &&
                        checked
                    ) {
                        usedSusp += Number(item.useSusp);
                    }
                });

                const newTotalSusp = (Number(totalSusp) + usedSusp).toFixed(2);
                if (newTotalSusp !== customerInfo.SuspenseDetails.totalSusp) {
                    setCustomerInfo(prev => ({
                        ...prev,
                        SuspenseDetails: {
                            ...prev.SuspenseDetails,
                            suspUse: '0.00',
                            // totalSusp: newTotalSusp,
                        }
                    }));
                }
                handleUseSuspenseApply();
            }
        });
    }, [agreementDetails]);

    // useEffect(()=>{
    //      handleUseSuspenseCancel();
    // }, [agreementDetails]);

    useEffect(() => {
        setCustomerSusp(customerInfo.SuspenseDetails.totalSusp || '0.00');
    }, [customerInfo.SuspenseDetails.totalSusp]);

    // setting the use suspense  amount against the agreement in the set to default condition 
    useEffect(() => {
        setSameStoreAgreement((prev: any) => {
            return prev.map((agr) => {
                const matchingAgreement = agreementDetails.find(ad => ad.agreementNumber === agr.agreementNumber);
                return {
                    ...agr,
                    useSusp: Number(matchingAgreement?.mxSuspenseDetails?.suspUse) > 0 ? matchingAgreement?.mxSuspenseDetails?.suspUse : '0.00'
                };
            });
        });
    }, [agreementDetails]);


    const classes = availableCreditsStyle();
    const classes2 = barcodeStyles();
    const classes3 = takePaymentStyles();
    const { t } = useTranslation('BackRent');
    const currentStore = window.sessionStorage.getItem('storeNumber');

    const isAgreementSelected = () => {
        console.log('isAgreementSelected here', agreementDetails.some((agr) => agr.storeNumber == currentStore && agr.selected));
        return agreementDetails.some((agr) => agr.storeNumber == currentStore && agr.selected);
    }

    const bindSuspense = () => {
        return (
            <Grid style={{ display: 'flex' }}>
                <Grid style={{ width: '50%' }}>
                    <Grid style={{ marginTop: '15px' }}>
                        <Typography className={classes.suspenseFont}>
                            {t("Suspense")}
                        </Typography>
                    </Grid>
                    <Grid style={{ marginTop: '20px' }}>
                        <Typography style={{ height: '54px', fontFamily: 'OpenSans-bold', fontSize: '30px' }}>
                            ${customerSusp}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '50%', textAlign: 'right' }}>
                    {featureFlags.EnableAddSuspense == '1' ? <Grid>
                        <RACButton
                            variant="outlined"
                            color="primary"
                            className={`${classes.mt15} ${classes.btnw153}`}
                            onClick={() => {
                                setEnableAddSuspense(true);
                            }}
                            loading={addBtnLoading}
                            disabled={!enableAddBtn}
                        >
                            {t("Add Suspense")}
                        </RACButton>
                    </Grid> : null}
                    {featureFlags.EnableUseSuspense == '1' ? <Grid>
                        <RACButton
                            variant="contained"
                            color="primary"
                            onClick={() => { setEnableUseSuspense(true) }}
                            className={`${classes.mt15} ${classes.btnw153}`}
                            loading={useBtnLoading}
                            disabled={!isAgreementSelected() || Number(customerInfo.SuspenseDetails.totalSusp) <= 0}
                        >
                            {t("Use Suspense")}
                        </RACButton>
                    </Grid> : null}
                </Grid>
            </Grid>
        );
    }

    function handleAmountChange(event: React.ChangeEvent<HTMLInputElement>) {
        const newAmount = event.target.value;
        setAddSuspenseAmt(newAmount);
    }

    function onBlurAmountChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value == '' ? '0' : event.target.value;
        const parsedValue = parseFloat(value.replace(/,/g, CONSTANTS.EMPTY_STRING));
        const cashAmountString = isNaN(parsedValue) ? "0.00" : parsedValue.toFixed(2);
        setAddSuspenseAmt(cashAmountString);
    }

    const handleAddSuspense = async () => {
        setAddBtnLoading(true);
        const amountDue = customerInfo.amountUsed.remainingAmountDue
        const prevSusAdd = customerInfo.SuspenseDetails.suspAdd;
        // const totalSuspense = (Number(customerInfo.SuspenseDetails.suspAdd) + Number(addSuspenseAmt)).toFixed(2);
        // const intialSus = Number(customerInfo?.SuspenseDetails?.intialSusp);
        // setCustomerSusp((Number(intialSusp) + Number(totalSuspense)).toFixed(2));

        // api call for the  add suspense
        //payload formation 
        const payload = suspensePayloadFormation(currentStore, addSuspenseAmt, "ADD")
        const response = await calculatePaymentModule(payload);
        let addedSusTax = '0.00';
        let addedSusWithoutTax = '0.00';
        if (response.status == '200') {
            addedSusTax = (Number(response.data?.paymentDetails?.[0]?.accountBalance?.[0]?.tax))?.toFixed(2)
            addedSusWithoutTax = (Number(response.data?.paymentDetails?.[0]?.accountBalance?.[0]?.amount))?.toFixed(2)
        }
        else {
            // cancel logic should be handled
            setAddBtnLoading(false);
            seterrorPopup(true);
            setAddSuspenseAmt('0.00');
        }
        console.log('addedSusTax', addedSusTax)
        setCustomerInfo((prev) => ({
            ...prev,
            SuspenseDetails: {
                ...prev.SuspenseDetails,
                suspAdd: Number(addSuspenseAmt).toString(),
                susAddTax: addedSusTax,
                susAddWthoutTax: addedSusWithoutTax,
                // totalSusp: (Number(intialSus) + Number(totalSuspense)).toFixed(2)
            },
            change:{
                ...prev.change,
                type:'change',
            },
            amountUsed: {
                ...prev.amountUsed,
                remainingAmountDue: (Number(amountDue) + (Number(addSuspenseAmt) - Number(prevSusAdd))).toFixed(2),
            }
        }));
        setAddBtnLoading(false);
    }
    function suspensePayloadFormation(storeNumber, amount, action) {
        return {
            storeNumber: storeNumber,
            paymentOrigin: 'S',
            physicalStoreNumber: storeNumber,
            customerId: customerInfo.customerId,
            customerAccount: [
                {
                    actionType: action == 'ADD' ? 'C' : 'D',
                    accountType: 'HTNWSUSP',
                    storeNumber: storeNumber,
                    amount: amount

                }
            ]

        };
    }

    function useSuspensePayloadFormation(storeNumber, amount, action, agreementNumber) {
        let changeEnabled = false;
        agreementDetails.map((agr) => {
            console.log('changeEnabled ', agr.agreementNumber);
            if (agr.agreementId == agreementNumber && Number(agr.totalDueAmount) < Number(amount)) {
                changeEnabled = true;
                setEnableSusRadio(true);
            }
        }
        )
        let toalUsedSus = '0.00'
        sameStoreAgreement.map((agr) => {
            if (Number(agr.useSusp) > 0) {
                toalUsedSus = (Number(toalUsedSus) + Number(agr.useSusp)).toFixed(2);
            }
        });
        return {
            actionType: action == 'ADD' ? 'C' : 'D',
            accountType: 'HTNWSUSP',
            storeNumber: storeNumber,
            amount: amount,
            agreementId: agreementNumber,
            withdrawFromAccount: (Number(toalUsedSus) > Number(customerInfo.amountUsed.remainingAmountDue) || changeEnabled) && paymentWithdrawCheckbox ? "Y" : "N"

        }
    }


    const handleCancelSuspense = () => {
        setAddBtnLoading(true);
        const suspenseAmt = addSuspenseAmt;
        // const totalSuspense = ((Number(customerInfo.SuspenseDetails.intialSusp)) - Number(customerInfo.SuspenseDetails.suspUse)).toFixed(2);
        const amountDue = (Number(customerInfo.amountUsed.remainingAmountDue) - Number(suspenseAmt)).toFixed(2);
        setCustomerInfo((prev) => ({
            ...prev,
            SuspenseDetails: {
                ...prev.SuspenseDetails,
                suspAdd: '0.00',
                susAddWthoutTax: '0.00',
                susAddTax: '0.00'
                // totalSusp: totalSuspense
            },
            amountUsed: {
                ...prev.amountUsed,
                remainingAmountDue: amountDue,
            }
        }));
        // setCustomerSusp((Number(customerInfo.SuspenseDetails.totalSusp)).toFixed(2));
        setAddSuspenseAmt('0.00');
        setAddBtnLoading(false);

    }

    const addSuspenseModal = () => {
        const isAddButtonEnabled = parseFloat(addSuspenseAmt.replace(/,/g, '')) > 0;

        return (
            <Grid>
                <Grid>
                    <Typography style={{ fontFamily: 'OpenSans-bold' }}>
                        {t("Suspense Amount")}
                    </Typography>
                </Grid>
                <Grid>
                    <RACTextbox
                        isCurrency={true}
                        OnChange={handleAmountChange}
                        name="add_suspense"
                        id="addSuspense"
                        type={"number"}
                        digitFormat={'currency'}
                        maxlength={9}
                        value={addSuspenseAmt}
                        className={classes.custDigitN1}
                        Onblur={onBlurAmountChange}
                    />
                </Grid>
                <Grid style={{ display: 'flex', float: 'right', marginTop: '15px' }}>
                    <Grid>
                        <RACButton
                            variant="outlined"
                            color="primary"
                            onClick={() => { handleCancelSuspense(); setEnableAddSuspense(false) }}
                        >
                            {t("Cancel")}
                        </RACButton>
                    </Grid>
                    <Grid>
                        <RACButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                handleAddSuspense();
                                setEnableAddSuspense(false);
                            }}
                            className={classes.addBtn}
                            disabled={!isAddButtonEnabled}
                        >
                            {t("Add")}
                        </RACButton>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    const suspenseTableHead = () => (
        <>
            <RACTableCell className={classes2.agreementCell} style={{ backgroundColor: '#fffcfcff', fontWeight: 'bold', minWidth: '150px' }}>{t("Agreement #")}</RACTableCell>
            <RACTableCell className={classes2.agreementCell} style={{ backgroundColor: '#fffcfcff', fontWeight: 'bold', minWidth: '185px' }}>{t("Schedule")}</RACTableCell>
            <RACTableCell className={classes2.agreementCell} style={{ backgroundColor: '#fffcfcff', fontWeight: 'bold' }}>{t("EPO")}</RACTableCell>
            <RACTableCell className={classes2.agreementCell} style={{ backgroundColor: '#fffcfcff', fontWeight: 'bold' }}>{t("Payment")}</RACTableCell>
            <RACTableCell className={classes2.agreementCell} style={{ backgroundColor: '#fffcfcff', fontWeight: 'bold', maxWidth: '80px' }}>{t("New Suspense")}</RACTableCell>
        </>
    );

    const suspenseTableBody = () => (
        <>
            {
                agreementDetails.map((agr: any) => {
                    if (agr.storeNumber == currentStore && agr.selected) {
                        return (
                            <RACTableRow key={agr.agreementNumber}>
                                <RACTableCell className={classes2.agreementCell} style={{ padding: '10px', backgroundColor: '#fffcfcff' }}>
                                    <Grid className={classes2.displayflex} style={{ alignItems: 'center', marginLeft: '12px' }}>
                                        <Typography>
                                            {agr.agreementNumber}
                                        </Typography>
                                    </Grid>
                                </RACTableCell>
                                <RACTableCell style={{ padding: '10px', backgroundColor: '#fffcfcff', }}>
                                    <Grid>
                                        <Typography style={{ marginLeft: '15px', color: '#606D89' }}>
                                            {agr.agreementSchedule}
                                        </Typography>
                                    </Grid>
                                </RACTableCell>
                                <RACTableCell style={{ padding: '10px', backgroundColor: '#fffcfcff' }}>
                                    <Grid>
                                        <Typography style={{ textAlign: 'right', marginRight: '25px', color: '#606D89' }}>
                                            {agr.epoAmount}
                                        </Typography>
                                    </Grid>
                                </RACTableCell>
                                <RACTableCell style={{ padding: '10px', backgroundColor: '#fffcfcff' }}>
                                    <Grid>
                                        <Typography style={{ textAlign: 'right', marginRight: '25px', color: '#606D89' }}>
                                            {calculateAgreementAmt(agr)}
                                        </Typography>
                                    </Grid>
                                </RACTableCell>
                                <RACTableCell style={{ padding: '10px', backgroundColor: '#fffcfcff' }}>
                                    <Grid style={{ maxWidth: '231px' }}>
                                        <RACTextbox
                                            isCurrency={true}
                                            name="add_suspense"
                                            id="addSuspense"
                                            type={"number"}
                                            digitFormat={'currency'}
                                            maxlength={9}
                                            className={` ${classes.custDigitN2}`}
                                            value={agreementSuspenseAmt(agr.agreementNumber)}
                                            OnChange={(e) => setUseSuspenseAmt(e, agr.agreementNumber)}
                                            Onblur={(e) => { useSuspenseBlurEvent(e, agr.agreementNumber, agr.agreementType, agr.agreementId) }}

                                        />
                                        {/* Display error message if exists */}
                                        {errorMessages[agr.agreementNumber] && (
                                            <Typography style={{ color: 'red', fontSize: '12px' }}>
                                                {t(errorMessages[agr.agreementNumber])}
                                            </Typography>
                                        )}
                                    </Grid>
                                </RACTableCell>
                            </RACTableRow>
                        );
                    }
                })
            }
        </>
    );

    const handleUseSuspenseCancel = () => {
        setUseBtnLoading(true);

        let usedSusp = 0;
        const totalSusp = customerInfo.SuspenseDetails.totalSusp;
        const intialSus = customerInfo.SuspenseDetails.intialSusp;
        // to validate the change amount
        sameStoreAgreement.map((el) => {
            if (Number(el.useSusp) > 0) {
                usedSusp = usedSusp + Number(el.useSusp);
            }
        })
        setCustomerInfo((prev) => ({
            ...prev,
            SuspenseDetails: {
                ...prev.SuspenseDetails,
                suspUse: '0.00',
                totalSusp: Number(intialSus).toFixed(2),
            },

        }))
        setErrorMessages({});
        const cloneSameStoreAgmt = sameStoreAgreement.map((agr: useSuspenseInterface) => {
            return {
                ...agr,
                useSusp: '0.00',
                erorMsg: '',
            }
        })
        setSameStoreAgreement(cloneSameStoreAgmt);
        // setAgreementDetails(prev =>
        //     prev.map(agr => {
        //         if (agr.storeNumber === currentStore) {
        //             return {
        //                 ...agr,
        //                 mxSuspenseDetails: {
        //                     ...agr.suspenseDetails,
        //                     suspUse: '0.00',
        //                 }
        //             };
        //         }
        //         return agr;
        //     })
        // );
        setAgreementDetails(agreementDetailsDeepClone)
        setEnableUseSuspense(false);
        setErrorMessages({});
        setUseBtnLoading(false);
        setPaymentWithdrawCheckbox(false);
        setEnableSusRadio(false);
        setUseSusBalAmt('0.00');
        setUseSusDisplayAmt('0.00');
    }
    const ErrorMsgPopup = () => {
        return (
            <Grid item md={12}>
                <Grid item md={12} className={classes3.textCenter}>
                    <Alerticon></Alerticon>
                    <Typography variant={'body2'} className={classes3.RACPOPMsg}>
                        {t("Something went wrong.")}
                    </Typography>
                </Grid>
                <Grid
                    container
                    className={`${classes3.justifycontentcenter} ${classes3.spacerMT4}`}
                >
                    <RACButton
                        variant="contained"
                        color="primary"
                        isRounded={false}
                        onClick={() => window.location.reload()}
                    >
                        {t('Ok')}
                    </RACButton>
                </Grid>
            </Grid>
        );
    };

    const getLatestSameStoreAgreement = () => {
        return sameStoreAgreement.map(agr => {
            const isSelected = agreementDetails.some(
                det => det.agreementNumber === agr.agreementNumber && det.selected
            );
            return isSelected ? agr : { ...agr, useSusp: 0.00 };
        });
    };

    const handleUseSuspenseApply = async () => {
        setUseBtnLoading(true);
        let usedSuspAmt = 0;
        let reducedAmt = 0;
        const prevUseSusBal = useSusBalAmt;
        const effectiveSameStoreAgreement = getLatestSameStoreAgreement();

        // ---- Calculate used suspense amount ----
        effectiveSameStoreAgreement.forEach((agr: any) => {
            if (Number(agr.useSusp) > 0) {
                usedSuspAmt += Number(agr.useSusp) || 0;
            }
        });

        console.log('Used Suspense Amount:', usedSuspAmt);

        // ---- Early return if no change ----
        if (usedSuspAmt.toFixed(2) == customerInfo.SuspenseDetails.suspUse) {
            console.log('No suspense change detected, skipping update.');
            setUseBtnLoading(false);
            return;
        }
        if (usedSuspAmt < Number(customerInfo.SuspenseDetails.suspUse)) {
            reducedAmt = Number(customerInfo.SuspenseDetails.suspUse) - usedSuspAmt;
            console.log('Reduced suspense:', reducedAmt);
        }

        const customerSusp = customerInfo.SuspenseDetails.intialSusp;
        let newCustomerSusp = '0.00';

        // ---- Prepare agreements with unique map ----
        const uniqueAgreementMap = new Map<string, { agreementNumber: string; agreementId: string; useSusp: string; }>();
        effectiveSameStoreAgreement.forEach(agr => {
            if (!uniqueAgreementMap.has(agr.agreementNumber)) {
                const detail = agreementDetails.find(
                    el => el.storeNumber == currentStore && el.agreementNumber == agr.agreementNumber
                );
                if (detail) {
                    uniqueAgreementMap.set(agr.agreementNumber, {
                        agreementNumber: agr.agreementNumber,
                        agreementId: detail.agreementId,
                        useSusp: String(agr.useSusp)
                    });
                }
            }
        });
        const uniqueAgreements = Array.from(uniqueAgreementMap.values());
        console.log('Unique Agreements:', uniqueAgreements);

        // ---- Arrays for payloads/results ----
        const payloadArr: any[] = [];
        const commonModulePayloadRes: any[] = [];

        for (const ua of uniqueAgreements) {
            const matchingDetail = agreementDetails.find(detail => detail.agreementId == ua.agreementId);
            if (matchingDetail) {
                const commonModulePayload = await calculationModulePayloadFormation({
                    customerId: customerInfo.customerId,
                    storeNumber: currentStore,
                    checkedAgr: [matchingDetail],
                    mxSus: matchingDetail.isZeroPayment
                });
                commonModulePayloadRes.push({ ...commonModulePayload, agreementId: ua.agreementId });
                console.log('Common Module Payload:', commonModulePayloadRes);
            }
            if (Number(ua.useSusp) > 0) {
                payloadArr.push(useSuspensePayloadFormation(currentStore, ua.useSusp, "USE", ua.agreementId));
            }
        }

        // ---- Map agreementAmountDue for each payload ----
        const agreementAmountDueArr = payloadArr
            .map(pa => {
                const cmPayload = commonModulePayloadRes.find(res => res.agreementId == pa.agreementId);
                return cmPayload ? cmPayload.agreementAmountDue : undefined;
            })
            .flat()
            .filter(Boolean);

        const payload = {
            storeNumber: currentStore,
            paymentOrigin: 'S',
            physicalStoreNumber: currentStore,
            customerId: customerInfo.customerId,
            customerAccount: payloadArr,
            agreementAmountDue: agreementAmountDueArr,
        };

        console.log('Final API payload:', payload);

        // ---- API Call for calculation ----
        const response = await calculatePaymentModule(payload);
        let storeTotalAmt = 0;
        let storeTotalTax = 0;
        let changeAmt = '0.00'; 

        // ---- Update agreementDetails with immutable map ----
        if (response.status == '200') {
            const resp = response?.data?.paymentDetails?.[0]?.agreementPaymentDetails || [];
            changeAmt = response?.data?.paymentDetails?.[0]?.amountWithdrawalFromAccount || '0.00';
            response?.data?.accountBalance?.map((el) => {
                if (el.storeNumber == currentStore && el.customerAccountTypeRef == 'HTNWSUSP') {
                    newCustomerSusp = el.accountBalance;
                }
            })
            // if User wants the remaining amount in suspense 
            if (enableOverPaymentCheckbox() && !paymentWithdrawCheckbox) {
                let useSusDisAmt = '0.00';
                response?.data?.paymentDetails?.[0]?.agreementPaymentDetails?.map((el) => {
                    console.log('changeAmt 3', el.amountDetails);
                    el.amountDetails.map((el) => {
                        if (el.itemCategory == 'HTNWSUSAPP') {
                            useSusDisAmt = (Number(useSusDisAmt) + Number(el.amount)).toFixed(2);
                            console.log('changeAmt 3', changeAmt);
                        }
                    })
                })
                console.log('changeAmt 1', changeAmt);
                effectiveSameStoreAgreement.map((el) => {
                    if (Number(el.useSusp) > 0) {
                        useSusDisAmt = (Math.abs(Number(useSusDisAmt) - Number(el.useSusp))).toFixed(2);
                    }
                })
                setUseSusDisplayAmt(useSusDisAmt);
            }

            setAgreementDetails((prev: any) =>
                prev.map((agrd: any) => {
                    let withdrwAmt = '0.00';
                    const matchedAgr = resp.find((agr: any) => {
                        if (agr.agreementId === agrd.agreementId) {
                            agr?.amountDetails?.forEach((el) => {
                                if (el.itemCategory === "HTNWSUSAPP") {
                                    withdrwAmt = el.amount;
                                }
                            });
                            return true;
                        }
                        return false;
                    });

                    console.log('AgreementId:', agrd.agreementId, 'Matched:', !!matchedAgr);

                    if (matchedAgr && agrd.storeNumber == currentStore) {
                        const updatedAgreement = {
                            ...agrd,
                            totalTax: Number(matchedAgr?.totalTax).toFixed(2),
                            totalDueAmount: (Number(matchedAgr?.totalAmount) + Number(matchedAgr?.totalTax)).toFixed(2),
                            totalAmount: Number(matchedAgr?.totalAmount).toFixed(2),
                            withdrawAmt: withdrwAmt,
                        };
                        console.log('Agreement updated:', updatedAgreement);
                        return updatedAgreement;
                    }
                    return agrd;
                })
            );
        } else {
            setUseBtnLoading(false);
            console.log('API call failed, status:', response.status);
            seterrorPopup(true);
        }

        // ---- Update customer info ----
        const prevChangeAmt = customerInfo.change.amount
        console.log("change amount ", Number(prevChangeAmt) + Number(changeAmt), prevChangeAmt, customerInfo.change.amount);
        setCustomerInfo((prev) => ({
            ...prev,
            SuspenseDetails: {
                ...prev.SuspenseDetails,
                suspUse: usedSuspAmt.toFixed(2),
                totalSusp: Number(newCustomerSusp).toFixed(2),
                susUseWithoutTax: Number(newCustomerSusp).toFixed(2),
            },
            change: {
                ...prev.change,
                amount: (Number(prevChangeAmt) + (Number(changeAmt) - Number(prevUseSusBal))).toFixed(2)
            }
        }));
        setCustomerSusp(Number(newCustomerSusp).toFixed(2));
        setUseBtnLoading(false);
        setUseSusBalAmt(changeAmt);
    };

    const isApplyButtonEnabled = () => {
        const hasErrors = sameStoreAgreement.some(agr => errorMessages[agr.agreementNumber]);
        const hasValidAmount = sameStoreAgreement.some(agr => Number(agr.useSusp) > 0);
        return !hasErrors && hasValidAmount;
    };

    const enableOverPaymentCheckbox = () => {
        // Check if any agreement allows overpayment
        let toalUsedSus = '0.00'
        const enableCheckbox = sameStoreAgreement.some((agr) => {
            if (Number(agr.useSusp) > 0) {
                toalUsedSus = (Number(toalUsedSus) + Number(agr.useSusp)).toFixed(2);
                return agreementDetails.some((ad) =>
                    agr.agreementNumber === ad.agreementNumber &&
                    Number(agr.useSusp) > Number(calculateAgreementAmt(ad))
                );
            }
            return false;
        });
        const hasErrorMessages = sameStoreAgreement.some((agr) => errorMessages[agr.agreementNumber] && errorMessages[agr.agreementNumber].length > 0);

        return (enableCheckbox || Number(toalUsedSus) > Number(customerInfo.amountUsed.remainingAmountDue)) && !hasErrorMessages;
    }

    const useSuspenseModal = () => {
        return (
            <>
                <RACTable
                    className={`${classes2.racGrid} ${classes2.mb32}`}
                    style={{ backgroundColor: '#fff', color: '#000' }}
                    renderTableHead={suspenseTableHead}
                    renderTableContent={suspenseTableBody}
                />
                {enableOverPaymentCheckbox() ? <Grid>
                    <Typography style={{ color: '#606D89', marginLeft: '10px' }}>
                        <RACCheckBox
                            // className="form-check-input me-1"
                            name="assignAlertChecked"
                            checked={paymentWithdrawCheckbox}
                            //disabled={disableAlert}
                            //   onChange={() =>
                            //     Assignalertclear(
                            //       isAlertExist === false ? 'add' : 'remove',
                            //       addAlertObj,
                            //       val.alertTypeId
                            //     )
                            //   }
                            onChange={() => { setPaymentWithdrawCheckbox(!paymentWithdrawCheckbox) }}
                        />
                        {t('Customer wants to withdraw the suspense amount as change')}
                    </Typography>
                </Grid> : null}
                <Grid style={{ display: 'flex', float: 'right', marginTop: '15px' }}>
                    <Grid>
                        <RACButton
                            variant="outlined"
                            color="primary"
                            onClick={() => { handleUseSuspenseCancel(); setEnableAddSuspense(false) }}
                        >
                            {t("Cancel")}
                        </RACButton>
                    </Grid>
                    <Grid style={{ marginLeft: '10px' }}>
                        <RACButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                handleUseSuspenseApply();
                                setEnableUseSuspense(false);
                            }}
                            className={classes.addBtn}
                            disabled={!isApplyButtonEnabled()}
                        >
                            {t("Apply")}
                        </RACButton>
                    </Grid>
                </Grid>
            </>
        );
    }

    // calculate the agreement suspense amount 
    const agreementSuspenseAmt = (agreementNumber: string) => {
        let agreementSuespenseAmt;
        sameStoreAgreement.forEach((agr: any) => {
            if (agr.agreementNumber == agreementNumber) {
                agreementSuespenseAmt = agr.useSusp;
            }
        })
        return agreementSuespenseAmt;
    }

    // setting the use suspense amt for the corresponding agreement
    const setUseSuspenseAmt = (e: React.ChangeEvent<HTMLInputElement>, agreementNumber: string) => {
        const newValue = e.target.value.replace(/,/g, '');
        setErrorMessages(prev => ({
            ...prev,
            [agreementNumber]: ''
        }));
        setSameStoreAgreement(prev =>
            prev.map(agr =>
                agr.agreementNumber == agreementNumber
                    ? { ...agr, useSusp: newValue }
                    : agr
            )
        );
    };

    // Updated use suspense blur event with validation logic
    const useSuspenseBlurEvent = (event, agreementNumber, agreementType?, agrId?) => {
        console.log('useSuspenseBlurEvent ', agreementNumber, agreementType, agrId);
        const value = event.target.value == '' ? '0.00' : event.target.value;
        let parsedValue = 0;
        let agreementAmt = 0;
        sameStoreAgreement.map((el) => {
            if (Number(el.useSusp) > 0) {
                parsedValue = parsedValue + Number(el.useSusp)
            }
            if (Number(el.useSusp) > 0 && el.agreementNumber == agreementNumber) {
                agreementAmt = agreementAmt + Number(el.useSusp)
            }
        })
        console.log('cashAmountString ', sameStoreAgreement);
        let cashAmountString;
        sameStoreAgreement.map((el) => {
            if (el.agreementNumber == agreementNumber) {
                cashAmountString = Number(el.useSusp).toFixed(2);
            }

        })

        // Find the corresponding agreement
        const agreement = agreementDetails.find(agr => agr.agreementNumber == agreementNumber);

        // Validate against suspense and EPO amounts
        const totalSuspense = Number(customerInfo.SuspenseDetails.intialSusp);
        const epoAmount = Number(agreement?.epoAmount || 0);

        let errorMessage = '';
        console.log('parsed value ', Number(parsedValue.toFixed(2)));
        if (Number(parsedValue.toFixed(2)) > totalSuspense) {
            errorMessage = "Amount is greater than Suspense";
        } else if (Number(agreementAmt.toFixed(2)) > epoAmount && agreementType != "Rental Item Sale" && agrId != 'Adjust') {
            errorMessage = "Amount is greater than EPO";
        }

        // Update error messages state
        setErrorMessages(prev => ({
            ...prev,
            [agreementNumber]: errorMessage,
        }));

        // Update the use suspense amount for the corresponding agreement
        setSameStoreAgreement(prev =>
            prev.map(agr =>
                agr.agreementNumber == agreementNumber
                    ? { ...agr, useSusp: cashAmountString }
                    : agr
            )
        );

        // Update agreement details with the new suspense amount
        setAgreementDetails(prev =>
            prev.map(agr => {
                if (agr.agreementNumber == agreementNumber && agr.storeNumber == currentStore) {
                    return {
                        ...agr,
                        mxSuspenseDetails: {
                            ...agr.suspenseDetails,
                            suspUse: cashAmountString
                        }
                    };
                }
                return agr;
            })
        );
    }

    // component declaration
    return (
        <>
            {/* <ClipLoader color="blue" loading={loading} size={40} /> */}
            <Grid container data-testid="suspense" className={`${classes.respw100}`}>
                <Grid item className={`${classes.w100} ${classes.floatLeft} ${classes.mb2}`}>
                    <Typography variant="h6" className={`${classes.floatLeft} ${classes.mt2} ${classes.raccollg8} ${classes.title}`}>
                        {t("Available Suspense")}
                    </Typography>
                </Grid>

                <Grid item className={`${classes.w100} ${classes.floatLeft}`}>
                    <Card className={`${classes.card} ${classes.w100} ${classes.floatLeft} ${classes.p3}`} style={{ marginBottom: "20px" }}>
                        <CardContent className={classes.p0}>
                            {bindSuspense()}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {enableAddSuspense &&
                <RACModalCard
                    isOpen={enableAddSuspense}
                    onClose={() => { handleCancelSuspense(); setEnableAddSuspense(false) }}
                    title={t("Add Suspense ")}
                    closeIcon={true}
                    borderRadius={"5px"}
                    maxWidth="xs"
                    // eslint-disable-next-line react/no-children-prop
                    children={addSuspenseModal()}
                />
            }

            {enableUseSuspense &&
                <RACModalCard
                    isOpen={enableUseSuspense}
                    onClose={() => { handleUseSuspenseCancel(); setEnableUseSuspense(false); }}
                    title={t("Use Suspense ")}
                    closeIcon={true}
                    borderRadius={"5px"}
                    maxWidth="xs"
                    // eslint-disable-next-line react/no-children-prop
                    children={useSuspenseModal()}
                    className={classes2.maxWidth850px}
                    classes={{
                        dialogTitle: `${classes2.fz20px}`,
                    }}
                />
            }
            {
                errorPopup ?
                    <RACModalCard
                        isOpen={errorPopup}
                        closeIcon={true}
                        borderRadius="20px"
                        maxWidth="xs"
                        onClose={() => window.location.reload()}
                        // eslint-disable-next-line react/no-children-prop
                        children={ErrorMsgPopup()}
                    />
                    : null
            }
        </>
    );
}